import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const welfareAssignmentsRoutesDictionary = moduleRouteDictionaryFactory(
  'welfareAssignments',
  'welfare-assignments',
  {
    list: 'list',
    detail: 'detail/:id',
    edit: 'edit/:id',
    completePlanDetail: 'complete-plan/detail/:id',
    completePlanEdit: 'complete-plan/edit/:id',
    mealVoucherDetail: 'meal-voucher/detail/:id',
  },
);
